import React, { useEffect, useRef } from 'react';

let announcementId = 0;

export function announce(message, priority = 'polite') {
  let container = document.getElementById('a11y-live-region');
  if (!container) {
    container = document.createElement('div');
    container.id = 'a11y-live-region';
    container.setAttribute('aria-live', 'polite');
    container.setAttribute('aria-atomic', 'true');
    container.className = 'a11y-sr-only';
    document.body.appendChild(container);
  }
  container.textContent = '';
  requestAnimationFrame(() => {
    container.textContent = message;
  });
}

export function A11yAnnouncer({ message, priority = 'polite' }) {
  const ref = useRef(null);
  useEffect(() => {
    if (message && ref.current) {
      ref.current.textContent = '';
      requestAnimationFrame(() => {
        ref.current.textContent = message;
      });
    }
  }, [message]);
  return (
    <div
      ref={ref}
      role="status"
      aria-live={priority}
      aria-atomic="true"
      className="a11y-sr-only"
    />
  );
}
